import { type ReactElement } from "react";
import { useSelector } from "react-redux";

import i18n from "i18next";
import k from "src/i18n/keys";

import { getUser, getCurrentUserId } from "src/reducers";

import { Header as StyledHeader } from "./styles";
import { AppState } from "src/types";

const Header = (): ReactElement => {
  const user = useSelector(({ app }: { app: AppState }) =>
    getUser(app, getCurrentUserId(app)),
  );

  return (
    <>
      <h2>{i18n.t(k.HOME)}</h2>
      <StyledHeader>
        {i18n.t(k.WELCOME_BACK)}
        {"  "}
        {user.loading ? i18n.t(k.LOADING_USER) : user.displayName || user.email}
      </StyledHeader>
    </>
  );
};

export default Header;
